import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './NotFound.scss';

function NotFound() {
  useEffect(() => {
    const robots = document.querySelector('meta[name="robots"]');
    const previous = robots?.getAttribute('content');
    const previousTitle = document.title;
    robots?.setAttribute('content', 'noindex, follow');
    document.title = 'Page not found — Anna Hovan';
    return () => {
      robots?.setAttribute('content', previous ?? 'index, follow');
      document.title = previousTitle;
    };
  }, []);

  return (
    <div className='not-found'>
      <span className='not-found-code'>404</span>
      <h1 className='not-found-title'>Page not found</h1>
      <p className='not-found-text'>The page you are looking for does not exist or has been moved.</p>
      <div className='not-found-links'>
        <Link to='/'>Home</Link>
        <Link to='/works'>Works</Link>
      </div>
    </div>
  );
}

export default NotFound;
